import React from "react";
import { LoadioStoreHomeSectionTemplate } from "themes/administration/loadio/components";
import { LoadioStoreHomeSectionViewStore } from "administration/loadio/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new LoadioStoreHomeSectionViewStore(rootStore, componentProps),
    "loadioStoreHomeSectionViewStore"
)
class LoadioStoreHomeSection extends React.Component {
    render() {
        return <LoadioStoreHomeSectionTemplate {...this.props} />;
    }
}

export default LoadioStoreHomeSection;
